import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalInfo} from '../../../../core/models/notification.model';
import {RouteService} from '../../../../core/services/route.service';

@Component({
  selector: 'app-cancel-delivery',
  templateUrl: './cancel-delivery.component.html',
  styleUrls: ['./cancel-delivery.component.scss']
})
export class CancelDeliveryComponent implements OnInit {
  public transactionId: string;
  public showCancelDeliveryModal: boolean;
  public showNotificationModal: boolean;
  public cancelSuccess: ModalInfo = {
    text: 'Your delivery successfully canceled',
    submitButtonText: 'Back to Home page'
  };

  constructor(
    private routeService: RouteService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.transactionId = params.transactionId;
      this.showCancelDeliveryModal = true;
    });
  }

  public closingIsFinish(): void {
    this.showCancelDeliveryModal = false;
    this.showNotificationModal = true;
  }

  public backToHomePage(): void {
    const homePageUrl = this.routeService.getKyooTechPage();
    this.router.navigate([homePageUrl])
      .catch(error => console.log(error));
  }
}
